<!-- Desktop karls Header -->
<app-header-sidebar-menu (sidebarState)="onSidebarStateChange($event)"></app-header-sidebar-menu>

<div class=" header-wrapper d-none d-md-block normal-header" [class.show]="!isSticky">
    <app-header-promotion [custom_ticker]="custom_ticker"></app-header-promotion>
    <div class="row row-xl-12 px-lg-2">
        <div class="col-md-12 col-lg-3 text-center text-lg-start logo-tabs ps-lg-4 ps-xl-5 logo-sect">
            <app-header-logo *ngIf="showLogo"></app-header-logo>
        </div>
        <div class="col-md-12 col-lg-9">
            <div class="row">
                <div class="col-9">
                    <div class="d-flex align-items-center justify-content-center justify-content-lg-center py-0">
                        <app-header-nav *ngIf="showFirstRowHeader"></app-header-nav>
                    </div>
                </div>
              
            </div>
            <div class="row second-row justify-content-center">
                <div class="col-12 col-md-7 col-lg-8 col-xl-9 custom-col-left" [ngClass]="{ 'left-width': isWishlist}">
                    <app-header-search></app-header-search>
                </div>
                <div class="col-4 col-md-5 col-lg-4 col-xl-3 custom-col-right" [ngClass]="{ 'right-width': isWishlist}">
                    <div class="d-flex justify-content-start p-0">
                        <div class="shop-vehicle">
                            <!-- <button> SHOP BY VEHILCLE </button> -->
                        <app-shop-by-vehicle *ngIf="isSearchByVehicleDisabled"></app-shop-by-vehicle>
                        </div>
                        <app-header-cart-section *ngIf="showSecondRowHeader"></app-header-cart-section>
                    </div>
                </div>
            </div>
      
        </div>
    </div>
    <div class="row mt-0 d-flex justify-content-center align-items-center">
        <div class="col-12">
            <div class="d-flex align-items-center justify-content-center justify-content-lg-center py-0">
                <app-header-third-row *ngIf="showThirdRowHeader"></app-header-third-row>
            </div>
        </div>
    </div>

</div>

<!-- Sticky Header -->
<div class="sticky-header d-none d-md-block emp-sticky-header" [class.show]="isSticky">
    <div class="sticky-menu" [ngClass]="{ 'sticky-active': isSticky }">
        <app-header-sidebar-menu (sidebarState)="onSidebarStateChange($event)"></app-header-sidebar-menu>
    </div>
    <div class="header-wrapper py-2">
        <div class="row px-3">
            <div class="col-md-12 col-lg-2 text-center text-lg-center logo-tabs  ps-lg-5 d-flex justify-content-center"
                [routerLink]="'/'" (click)="onButtonClick()">
                <img *ngIf="showLogo" [src]="cdnImagePath + headerdata?.websiteHeader[firstObj + 2]?.desktop_logo"
                    alt="Logo" class="img-fluid d-none d-md-block desktop-img cursor-pointer" fetchpriority="high"
                    width="170" height="56" />
            </div>
            <div class="col-md-12 col-lg-10">
                <div class="row">
                    <div class="col-12 mt-1 col-md-7 col-lg-8 col-xl-9 mt-3 custom-col-left "
                        [ngClass]="{ 'left-width': isWishlist}">
                        <app-header-search></app-header-search>
                    </div>
                    <div class="col-4 col-md-5 col-lg-4 col-xl-3 mt-3 custom-col-right "
                        [ngClass]="{ 'right-width': isWishlist}">
                        <div class="d-flex justify-content-start p-0">
                            <div class="shop-vehicle">
                                <!-- <button> SHOP BY VEHILCLE </button> -->
                                 <app-shop-by-vehicle *ngIf="isSearchByVehicleDisabled"></app-shop-by-vehicle>
                            </div>
                            <app-header-cart-section *ngIf="showSecondRowHeader"
                                [showdowntooltip]="showdowntooltip"></app-header-cart-section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Mobile Header -->
<div class="container d-md-none">
    <app-header-mobile-menu [headerSettings]="headerSettings" [custom_ticker]="custom_ticker"></app-header-mobile-menu>
</div>
<app-shopping-cart *ngIf="showCart"></app-shopping-cart>